exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brogliacci-container {\r\n  max-height: 100%;\r\n  /* max-height: 150px; */\r\n  border-radius: 2px;\r\n  position: relative;\r\n  display: block;\r\n  background-color: #55aa78;\r\n  color: #ffffff;\r\n  text-align: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.brogliacci-box-header {\r\n  background-color: #ffffff;\r\n  color: #173348;\r\n  padding: 3px;\r\n  font-weight: bold;\r\n}\r\n\r\n.brogliacci-box-header p {\r\n  margin: 0px;\r\n}\r\n\r\n.brogliacci-container{\r\n  max-height: 100%;\r\n  overflow-y: auto;\r\n}\r\n.brogliacci-box {\r\n  padding-top: 15px;\r\n  padding-bottom: 50px;\r\n}\r\n.brogliacci-box > p {\r\n  font-size: 50px;\r\n}\r\n.brogliacci-box .button-container {\r\n  position: absolute;\r\n  width: 100%;\r\n  bottom: 10px;\r\n}\r\n.button-container button {\r\n  position: relative;\r\n  margin: auto;\r\n  background-color: #173348;\r\n  font-weight: bold;\r\n  border-radius: 20px;\r\n  border-color: transparent;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/brogliacci-incassi/brogliacci-incassi.component.css
// module id = ../../../../../src/app/components/utils/dynamic/components/brogliacci-incassi/brogliacci-incassi.component.css
// module chunks = main